// extracted by mini-css-extract-plugin
export var equalColumn = "_d3-0";